/**
 * cells — antd Table column.render 的共享渲染函式。
 *
 * 4 個 Tab 內容組件對「主編號 / 副字段 / 可空日期」的視覺處理一致，
 * 抽出避免重複。返回 ReactNode 而非組件，方便直接用於 column.render。
 */
import type { ReactNode } from 'react';
import { color, font, weight } from '@/styles/tokens';

/** 主編號列：mono + semibold + primary text。 */
export function MonoStrong(value: string): ReactNode {
  return (
    <span style={{ fontFamily: font.mono, fontWeight: weight.semibold, color: color.text.primary }}>
      {value}
    </span>
  );
}

/** 副字段（關聯編號 / 任務編號 / 日期）：mono + secondary text。 */
export function MonoMuted(value: string): ReactNode {
  return <span style={{ fontFamily: font.mono, color: color.text.secondary }}>{value}</span>;
}

/**
 * 可空日期欄位：
 *  - 有值 → 同 MonoMuted 樣式
 *  - 空值 / undefined / null → 顯示「—」（color.text.muted）
 */
export function MonoDateOrDash(value: string | undefined | null): ReactNode {
  if (!value) return <span style={{ color: color.text.muted }}>—</span>;
  return MonoMuted(value);
}
